module.exports = __webpack_public_path__ + "static/img/wechat.74e57e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/freetarget/wechat.png
// module id = g6I9
// module chunks = 0